import Vue from "vue";
import Router from "vue-router";

import trinity from "@/components/leads/ang-leads";
import narrowTemplate from "@/components/partials/misc/narrowTemplate";
Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      component: narrowTemplate,
      children: [{ path: "/", component: trinity }],
    },
  ],
});
